export default __webpack_public_path__ + "static/media/(4)Milhojas.e34d1988.jpg";